import forwardIcon from '../../../../../assets/img/forward.svg';

export interface ChatResourceItem {
  entryId: string;
  title: string;
  description: string;
  imgUrl?: string;
  url?: string;
}

interface ResourceCardProps {
  item: ChatResourceItem;
  onVisitSource?: (item: ChatResourceItem) => void;
  onAddToPatient?: (item: ChatResourceItem) => void;
  showAddToPatient?: boolean;
}

const ResourceCard = ({
  item,
  onVisitSource,
  onAddToPatient,
  showAddToPatient = false,
}: ResourceCardProps) => {
  return (
    <div className="chat-resource-card">
      {item.imgUrl ? (
        <img
          className="chat-resource-card__image"
          src={item.imgUrl}
          alt={item.title}
          loading="lazy"
        />
      ) : null}
      <div className="chat-resource-card__body">
        <div className="chat-resource-card__title">{item.title}</div>
        <div className="chat-resource-card__description">
          {item.description}
        </div>
        <div className="chat-resource-card__footer">
          <button
            type="button"
            className="chat-resource-card__action-button"
            onClick={() => onVisitSource?.(item)}
            disabled={!item.url}
          >
            <span className="chat-resource-card__visit">Visit source</span>
          </button>
          {showAddToPatient ? (
            <button
              type="button"
              className="chat-resource-card__action-button"
              onClick={() => void onAddToPatient?.(item)}
              aria-label={`Add ${item.title} to patient portal`}
            >
              <img
                className="chat-resource-card__share-icon"
                src={forwardIcon}
                alt=""
              />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;
